import React from 'react'
import { VerificationCodeInput } from './components/VerificationCode/VerificationCode'
import { Title, TopBanner, Wrapper, Header } from './DeleteAccount.styles'
import WelbeLogo from './WelbeLogo'
import { DeleteForm } from './components/DeleteForm/DeleteForm'
import { CompleteDelete } from './components/CompleteDelete/CompleteDelete'
import { useDeleteAccount } from './DeleteAccount.hooks'
import { Footer } from './components/Footer/Footer'
import { ComponentsProps, DefaultComponentProps } from './DeleteAccount.types'

const components: ComponentsProps = {
	deleteForm: DeleteForm,
	codeVerify: VerificationCodeInput,
	finished: CompleteDelete,
}

const ComponentByStep = (props: DefaultComponentProps) => {
	const { step, ...rest } = props
	const Component: any = components[step] || (() => null)

	return <Component {...rest} />
}

export const DeleteAccount = () => {
	const {
		step,
		payload,
		hasAgreed,
		isLoading,
		isLastStep,
		isInvalidForm,
		setHasAgreed,
		handlePrev,
		handleNext,
		setPayload,
		handleGetVerificationCode,
	} = useDeleteAccount()

	return (
		<>
			<Wrapper height={step === 'codeVerify' ? '100vh' : undefined}>
				<TopBanner />
				<Header>
					<WelbeLogo />
					<Title>{isLastStep ? 'Te extrañaremos' : 'Eliminar cuenta'}</Title>
				</Header>
				<ComponentByStep
					step={step}
					payload={payload}
					onChange={setPayload}
					hasAgreed={hasAgreed}
					onAgree={(state: boolean) => setHasAgreed(state)}
					onResend={() => handleGetVerificationCode()}
				/>
				<Footer
					agreed={hasAgreed}
					invalid={isInvalidForm}
					loading={isLoading}
					currentStep={step}
					onPrev={handlePrev}
					onNext={handleNext}
				/>
			</Wrapper>
		</>
	)
}
